// inventory-instance-root.ts — the object card's painter for a saved inventory instance.
//
// The claim lifecycle (possessor read through the page runtime, watches, release) lives in
// shared/inventory-instance-root.ts, which the inventory tile mounter shares. The card paints the instance's
// compiled node with the shell's page context, or a named refusal through the same card renderer.

import { buildNamesMapFromBlob, foldAmbientRootCatalogsIntoNames } from './build-names-map';
import { claimInventoryInstance } from '../shared/inventory-instance-root';
import type { InventoryInstanceRootRequest } from '../shared/inventory-instance-root';
import type { ReferencedNames } from './types';

export { INVENTORY_INSTANCE_ROOT, inventoryInstanceRootRequest, findCompiledInventoryNode, releaseInventoryInstanceClaim }
    from '../shared/inventory-instance-root';

type PaintCard = (value: unknown, names: ReferencedNames, container: HTMLElement) => boolean;

/** Claim `container` for `shell`'s instance; every possessor compile repaints the card it still owns. */
export function paintInventoryInstanceRoot(shell: Record<string, unknown>, request: InventoryInstanceRootRequest,
    names: ReferencedNames, container: HTMLElement, paintCard: PaintCard): void {
    claimInventoryInstance(request, container, {
        pending: el => { el.innerHTML = '<div class="text-muted small p-2" role="status">Loading…</div>'; },
        node: (node, el) => {
            // Resync can refresh the possessor's viewer verdict. Older runtimes still use the shell's verdict.
            const permissions = node.permissions ?? shell.permissions;
            const blob = { ...node, ...(permissions ? { permissions } : {}), _ft_object_card: shell._ft_object_card };
            paintCard(blob, { ...foldAmbientRootCatalogsIntoNames(buildNamesMapFromBlob(blob)), ...names }, el);
            return true;
        },
        refusal: (reason, el) => { paintCard({ _inventory_refusal: reason }, {}, el); },
    });
}
